import { Component } from "@angular/core";
import { PolicyHeaderComponent } from "../policy-header/policy-header.component";

@Component({
  selector: "app-il-00-17-11-98",
  standalone: true,
  imports: [PolicyHeaderComponent],
  templateUrl: "./il-00-17-11-98.component.html",
  styleUrl: "./il-00-17-11-98.component.scss",
})
export class Il00171198Component {}
